/*
 * Copyright (c) CIRROM 2025.
 */

import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
} from "@mui/material";
import styled from "@emotion/styled";

const SelectorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
`;

interface User {
  id: number;
  name: string;
}

interface UserSelectorProps {
  selectedUserId: number | "all";
  onUserChange: (userId: number | "all") => void;
  users: User[];
  label?: string;
  showAllOption?: boolean;
}

export const UserSelector: React.FC<UserSelectorProps> = ({
  selectedUserId,
  onUserChange,
  users,
  label = "Select User",
  showAllOption = true,
}) => {
  return (
    <SelectorContainer>
      <FormControl size="small" style={{ minWidth: 200 }}>
        <InputLabel>{label}</InputLabel>
        <Select
          value={selectedUserId}
          onChange={(e) => onUserChange(e.target.value as number | "all")}
          label={label}
        >
          {showAllOption && (
            <MenuItem value="all">All Users (Team View)</MenuItem>
          )}
          {users.map((user) => (
            <MenuItem key={user.id} value={user.id}>
              {user.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {selectedUserId !== "all" && (
        <Box>
          <Typography variant="body2" color="text.secondary">
            Viewing data for:{" "}
            <strong>{users.find((u) => u.id === selectedUserId)?.name}</strong>
          </Typography>
        </Box>
      )}
    </SelectorContainer>
  );
};
